/*
 * atob and btoa are causing encoding issues.
 * For example:
 * ```
 * atob(Buffer.from('vidéo', 'utf-8').toString('base64'))
 * ```
 * prints `vidÃ©o` instead of `vidéo`.
 *
 * @see https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */

export function base64Encode(raw: string): string {
  if ('Buffer' in globalThis) {
    return Buffer.from(raw, 'utf-8').toString('base64');
  } else {
    // see comment at file start
    const bytes = new TextEncoder().encode(raw);
    const binString = String.fromCodePoint(...bytes);
    return window.btoa(binString);
  }
}

export function base64Decode(raw: string): string {
  if ('Buffer' in globalThis) {
    return Buffer.from(raw, 'base64').toString('utf-8');
  } else {
    // see comment at file start
    const binString = window.atob(raw);
    const byteArray = (Uint8Array as any).from(binString, (m: any) => m.codePointAt(0));
    return new TextDecoder().decode(byteArray);
  }
}

export function extractPayloadFromToken(token: string): Record<string, any> {
  return JSON.parse(base64Decode(token.split('.')[1]));
}
